export default function SvgComplete() {
    return <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg" class="" data-v-6a9d7b17="" style={{ height: '20px', width: '20px' }}>
        <circle xmlns="http://www.w3.org/2000/svg" cx="12" cy="12" r="12" fill="#0d6efd"></circle>
        <path xmlns="http://www.w3.org/2000/svg" d="M6.8 12.1714L10.1548 15.6L17.2 8.4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>;
}